<template>
    <div class="bar_wrap">
        <div ref="barcharts" id="barcharts" class="barcharts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
let tooltip = {
      trigger: 'axis',
      axisPointer: {          // 坐标轴指示器，坐标轴触发有效
        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
      },
      confine: true
    },
    grid ={
      left: 20,
      right: 20,
      bottom: 15,
      top: 10,
      containLabel: true
    };
var option = {
    tooltip: tooltip,
    grid: grid,
    xAxis: [
      {
        type: 'value',
        min:0,
        max:100,
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        data:[0,20,40,60,80,100],
      },
      {
        position:'top',
        name:'',
        data:['一级','二级','三级','四级','五级'],
        axisLine:{ //坐标轴线
          show:false,
        },
        axisTick:{ //坐标轴刻度轴
          show:false
        }
      }
    ],
    yAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: [],
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        axisLabel:{
        		//interval: 0,
           //rotate: 20, 
            color: '#666'            
        },
       }
    ],
    series: [
      {
        name: '风险数值',
        type: 'bar',
        barWidth:22,
        barGap:'10%',
        label: {
          normal: {
            show: true,
            position: 'inside',
            textStyle: {	    //数值样式
                color: '#fff',
                fontSize: 12
            }
          }
        },
        data: [],
        itemStyle: {
          normal: {
            color: function(params) {
              let colorList=[];
              let value = params.value;
              if(value >= 0 && value <= 20){
                colorList = ['#009944', '#4EDD8E']
              }
              if(value > 20 && value <= 40){
                colorList = ['#A2E317', '#4EDD8E']
              }
              if(value>40 && value<=60){
                colorList = ['#FF9294', '#FFC17F']
              }
              if(value>60 && value<=80){
                colorList = ['#FF5409', '#FFB080']
              }
              if(value>80 && value<=100){
                colorList = ['#DD352A', '#F27269']
              }
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: colorList[0] },
                { offset: 1, color: colorList[1] }
              ]);
            },
            barBorderRadius: 2 //柱状角成椭圆形
          }
        }
      },
    ]
  };
 var option2 = {
    tooltip: tooltip,
    grid:grid,
    xAxis: [
      {
        type: 'value',
        min:-100,
        max:100,
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        data:[-100,-60,-20,0,60,100],
      },
      {
        position:'top',
        name:'',
        data:['中度减退','轻度减退','最佳','最佳','轻度亢进','中度亢进'],
        axisLine:{ //坐标轴线
          show:false,
        },
        axisTick:{ //坐标轴刻度轴
          show:false
        }
      }
    ],
    yAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: [],
        axisLine: {
          lineStyle: {
            color: '#999'
          }
        },
        axisLabel:{
        		//interval: 0,
           //rotate: 20, 
            color: '#666'            
        },
       }
    ],
    series: [
      {
        name: '修复数值',
        type: 'bar',
        barWidth:22,
        barGap:'10%',
        label: {
          normal: {
            show: true,
            position: 'inside',
            textStyle: {	    //数值样式
                color: '#fff',
                fontSize: 12
            }
          }
        },
        data: [],
        itemStyle: {
          normal: {
            color: function(params) {
              let colorList=[];
              let value = params.value;
              if (value >= -20 && value <= 20 ) {
              colorList = ['#009944', '#4EDD8E'] // 绿色
            }
            if (value >=  21 && value <= 100) {
              colorList = ['#FFAE04', '#FFD630'] // 橙色
            }
            if (value >= -100 && value <= -21 ) {
              colorList = ['#189FFC', '#9CD8FF'] // 蓝色
            }
              return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: colorList[0] },
                { offset: 1, color: colorList[1] }
              ]);
            },
            barBorderRadius: 2 //柱状角成椭圆形
          }
        }
      },
    ]
  };
export default {
  props: {
    barlist: {
      type: Array,
      default() {
        return []
      },
    },
    ifClick: {
      type: Boolean,
      default() {
        return false
      },
    },
    min: {
      type: Number,
      default() {
        return 0
      },
    },
    max: {
      type: Number,
      default() {
        return 100
      },
    },
  },
    data(){
        return{
        }
    },
    methods:{
        initCharts(){
            let charts = this.$echarts.init(this.$refs.barcharts);
           
            if(this.min===-100){
              option2.yAxis[0].data = this.barlist.map(e=>{
                return e.name
              })
              option2.series[0].data = this.barlist.map(e=>{
                return e.functional_status
              });
              charts.setOption(option2);
            }else{
              option.yAxis[0].data = this.barlist.map(e=>{
                return e.name
              })
              option.series[0].data = this.barlist.map(e=>{
                return e.functional_status
              });
              charts.setOption(option);
            }
          let that = this
          charts.on('click', function (params) {
            console.log('paramsbar', params.name)
            if(that.ifClick) {
              that.$emit('handle-organ', params.name)
            }
          });  
        }
    },
    created(){
      this.$nextTick(() => {
        this.initCharts()
      })
    }
}
</script>
<style lang="scss" scoped>
.barcharts{
  width: 700px;
  height: 610px;
}
</style>